import React from "react";

export default function Title({ myJSON, emulatorStep, overview }) {
  return (
    <div
      // className="body-title"
      className="flexed-title"
      style={{
        display: "inherit",
        position: overview && "absolute",
        left: overview && "60px",
        top: overview && "60px",
        width: "100%",
      }}
    >
      <div
        // className="title-bar"
        className="flexed-title-container"
      ></div>
      <p
        className="flexed-title"
        style={{
          fontFamily: myJSON.title.main_title.font_family
            ? myJSON.title.main_title.font_family
            : null,
          color: myJSON.title.main_title.color
            ? myJSON.title.main_title.color
            : null,
          width: myJSON.title.main_title.width
            ? myJSON.title.main_title.width
            : null,
          // lineHeight: window.navigator.platform.includes("Win") ? "40px" : null,
          margin: window.navigator.platform.includes("Win") ? "0" : "5px 0 0 0",
          zIndex: "400",
          whiteSpace: "nowrap",
          display: "inline",
        }}
      >
        {myJSON.title.main_title.text}
      </p>
      {myJSON.title.main_title.sim_text ? (
        <>
          <div className="ft-divider"></div>
          <p
            className="flexed-title"
            style={{
              color:
                myJSON.steps &&
                myJSON.steps[emulatorStep] &&
                myJSON.steps[emulatorStep].custom_overlay &&
                myJSON.steps[emulatorStep].custom_overlay.sim_text_color
                  ? myJSON.steps[emulatorStep].custom_overlay.sim_text_color
                  : myJSON.title.main_title.sim_text_color,

              margin: window.navigator.platform.includes("Win")
                ? "0"
                : "5px 0 0 0",
              display: "inline",
              whiteSpace: "nowrap",
            }}
          >
            {myJSON.title.main_title.sim_text}
          </p>
        </>
      ) : null}
    </div>
  );
}
